module.exports = __webpack_public_path__ + "img/two-envelopes.9362443b.svg";